import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { GatewayFirmwareUpdateActions } from './gateway-firmware-update.actions';
import { GatewayFirmwareUpdateSelectors } from './gateway-firmware-update.selectors';

@Injectable({ providedIn: 'root' })
export class GatewayFirmwareUpdateStore {
  constructor(private store: Store) {}

  updateStatus$ = this.store.select(GatewayFirmwareUpdateSelectors.getGatewayFirmwareUpdateStatus);

  updateFirmwareProcessStart(installationId: number, gatewaySerial: string): void {
    this.store.dispatch(
      GatewayFirmwareUpdateActions.GatewayFirmwareUpdateTriggerActions.installationProcessStart({
        installationId,
        gatewaySerial,
      })
    );
  }

  updateInProgress(): void {
    this.store.dispatch(GatewayFirmwareUpdateActions.updateInProgress());
  }
}
